import styled from 'styled-components';
import { Box } from '../../../CommonComponents/OPL/Box/Box';

export const Chart = styled(Box)({
  position: 'relative',
  inlineSize: 40,
  blockSize: 40,
  flex: '0 0 40px',
});

interface RingProps {
  progress: number;
}

export const Ring = styled(Box)<RingProps>(({ theme, progress }) => ({
  position: 'relative',
  inlineSize: '100%',
  blockSize: '100%',
  borderRadius: '50%',
  background: `conic-gradient(${
    progress === 100 ? theme.colors.success['500'] : theme.colors.primary['500']
  } calc(${progress} * 1%), ${theme.colors.neutral['100']} 0)`,

  '&::after': {
    content: "''",
    position: 'absolute',
    inset: '8px',
    borderRadius: '50%',
    background: theme.colors.bg,
  },
}));
